import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import { OpPlusBundle } from 'api/optimalprint-sdk.d';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import getCategoryId from 'store/category/selector/getCategoryId';
import getProductId from '../selector/getProductId';
import { setOPPlusContentAction } from '../slice';

const fetchOPPlusContentOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const categoryId = getCategoryId(store);
    const productId = getProductId(store);
    const response = (await apiRequest(
      endpoints.customerCartV1ProductOPPlusGet,
      {
        categoryId,
        productId,
      },
      'POST',
      'data',
    )) as OpPlusBundle.Entity.API.Membership.Response.V1.OpPlusProductsV1Response;

    if (!response) {
      // eslint-disable-next-line no-console
      console.error('Cannot fetch OPPlus data');
      return;
    }
    dispatch(setOPPlusContentAction(response));
  };

export default fetchOPPlusContentOperation;
